import React from "react";
import { useNavigate } from "react-router-dom";
import "./Other.css";
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";

const Other = () => {
  const navigate = useNavigate();
  useEscapeToGoBack();

  return (
    <div className="other-container">
      <h2 className="other-title">Other</h2>

      <div className="other-buttons">
        <button onClick={() => navigate("/cancel-redeem")}>Cancel - Redeem</button>
        
        {/* NEW: Cancel Grant */}
        <button onClick={() => navigate("/cancel-grant")}>Cancel - Grant</button>
        
        <button onClick={() => navigate("/report-lost")}>Report - Lost</button>
        <button onClick={() => navigate("/cancel-lost")}>Cancel - Lost</button>
        <button onClick={() => navigate("/print-lost-form1")}>Print - Lost Form 1</button>
        {/*<button onClick={() => navigate("/print-lost-list")}>Print - Lost List</button>*/}
        <button onClick={() => navigate("/police-seized")}>Police - Seized</button>
        <button onClick={() => navigate("/police-return")}>Police - Return</button>
        <button onClick={() => navigate("/print-sized-list")}>Print - Seized List</button>
        <button onClick={() => navigate("/cancel-renew")}>Cancel - Renewal</button>
        <button onClick={() => navigate("/cancel-renew-by-new")}>Cancel - Renewal(Double Renewal)</button>
        <button onClick={() => navigate("/delete-grant")}>Delete - Grant (Double Grant)</button>
        
        {/* NEW: Insert Renewal Record */}
        <button onClick={() => navigate("/insert-renewal-record")}>Insert Renewal Record</button>
        
        {/*<button onClick={() => navigate("/delete-renewal-record")}>Delete Renewal Record</button>*/}
        {/*<button onClick={() => navigate("/print-lost-form2")}>Print - Lost Form 2</button>*/}
        {/*<button onClick={() => navigate("/system-settings")}>System Settings</button>*/}
        {/* <button onClick={() => navigate("/change-gold-value")}>Change Gold Value</button> */}
        
        <button onClick={() => navigate("/nric-audit")}>
          Foreign Pawner Audit
        </button>
      </div>

      <button className="back-button" onClick={() => navigate("/dashboard")}>Back</button>
    </div>
  );
};

export default Other;